import { useState } from "react";
import { GetLocalStorage } from "./GetLocalStorage";

export function getMyPermissions() {
  let perm = GetLocalStorage("x-u-perm");
  if (perm) return perm;
  return [];
}

export const usePermissions = () => {
  const [userPermissions, setUserPermissions] = useState(getMyPermissions());
  return { userPermissions, setUserPermissions };
};
